module.exports = __webpack_public_path__ + "static/media/xl-cta-pattern-left-dark.100c8212.svg";